import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { GatewayAuthService, RoleAccessResponse } from 'src/app/services/gateway/gateway-auth.service';
import { Router } from '@angular/router';
import { faUser, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { NbAccessChecker } from '@nebular/security';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

    private destroy$: Subject<void> = new Subject<void>();
    userPictureOnly: boolean = false;
    showTitle: boolean = true;
    user: any;
    profile: any;

    currentTheme = 'corporate';

    userMenu = [{ title: 'Log out', link: '/logout' }];
    isCollapsed = true;
    faUser = faUser;
    faPowerOff = faPowerOff;

    // Gateway authorization state
    isGod: boolean = false;
    roleAccess: RoleAccessResponse | null = null;

    constructor(private sidebarService: NbSidebarService,
        private menuService: NbMenuService,
        private themeService: NbThemeService,
        private layoutService: LayoutService,
        private breakpointService: NbMediaBreakpointsService,
        public auth: AuthService,
        public router: Router,
        public accessChecker: NbAccessChecker,
        private gatewayAuth: GatewayAuthService) {
        // console.log(this.auth.access , 'access at the start')
        // console.log(this.auth.loggedIn , 'loggedin at the start ')
        // setTimeout(() => {
        // console.log(this.auth.access , 'access 2 seconds later')
        // console.log(this.auth.loggedIn , 'loggedin 2 seconds later')

        // },2000)
    }

    ngOnInit() {
        this.currentTheme = this.themeService.currentTheme;
        this.auth.userProfile$
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (profiles: any) => {
                    this.profile = profiles;
                    this.user = this.profile;
                }
            );

        const { xl } = this.breakpointService.getBreakpointsMap();
        this.themeService.onMediaQueryChange()
            .pipe(
                map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
                takeUntil(this.destroy$),
            )
            .subscribe((isLessThanXl: boolean) => this.userPictureOnly = false);

        this.themeService.onThemeChange()
            .pipe(
                map(({ name }) => name),
                takeUntil(this.destroy$),
            )
            .subscribe(themeName => this.currentTheme = themeName);

        // Subscribe to role/access resolved by the gateway
        this.gatewayAuth.roleAccess$
            .pipe(takeUntil(this.destroy$))
            .subscribe((ra) => {
                this.roleAccess = ra;
                this.isGod = !!ra && ra.role === 'god';
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    changeTheme(themeName: string) {
        this.themeService.changeTheme(themeName);
    }

    toggleSidebar(): boolean {
        this.sidebarService.toggle(true, 'menu-sidebar');
        this.layoutService.changeLayoutSize();

        return false;
    }

    navigateHome() {
        this.router.navigate(['/home']);
        return false;
    }
    navigateDashboard() {
        if (this.auth.access == ('subscriber')) {
            this.router.navigate(['/pages/reportsfleet']);
        } else if (this.auth.access.includes("publicCharging") && !this.auth.access.includes("payment")) {
            this.router.navigate(['/pages/publicfleet']);
        }   else if (this.auth.access.includes("fleet") && !this.auth.access.includes("payment")){
            this.router.navigate(['/pages/publicfleet']);
        }
        else if (this.auth.userRole == 'vendor' && this.auth.access.includes("accountant")) {
            this.router.navigate(['/pages/page-invoice']);
        }
        else {
            this.router.navigate(['/pages/dashboard']);
        }

        return false;
    }
    // navigateApp() {
    //     this.router.navigate(['/pages/app/home']);
    //     return false;
    // }

    onTestJwt() {
        // Trigger JWT test flow
        this.gatewayAuth.testJwt();
    }
}
